import Svg, { Path } from 'react-native-svg'
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const Download = ({ width = 16, height = 16, color = '#0F3CC9' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <Path
      fill={color}
      d="M7.527 11.807a.668.668 0 0 0 .946 0l3.334-3.334a.671.671 0 0 0-.217-1.091.67.67 0 0 0-.73.145l-2.193 2.2V2a.667.667 0 0 0-1.334 0v7.727l-2.193-2.2a.67.67 0 1 0-.947.946l3.334 3.334Zm3.806 1.527H4.667a.666.666 0 1 0 0 1.333h6.666a.667.667 0 1 0 0-1.333Z"
    />
  </Svg>
)
export default Download
